import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field, ErrorMessage } from "formik";
import { useUserAuth } from "@workspace/login";
import {
  tagJob,
  fetchJobForm,
  fetchJobTimelineFormSubmission,
} from "@workspace/job/src/store/actions";
import {
  trainCancelInterview,
  cancelInterview,
  addInterviewLogs,
} from "../../store/Interviews/action";
import { Form, ObjectHelper } from "@workspace/common";

const ModalFormWrapper = ({
  originalOrder = 10,
  activeStep = 16,
  jobTimeLineData,
  interview,
  isFormModalOpen,
  closeModal,
  isLoading,
  isCancel,
  handleCancelInterview,
  handleInterviewLogs,
  readOnlyInterviewNo,
  setRefreshKey,
  interviewDate,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getAllUserGroups } = useUserAuth();

  const formikRef = useRef(null);

  const form = useSelector((state) => state.JobFormReducer.form);
  const [formTemplate, setFormTemplate] = useState(null);

  const formSubmissionData = useSelector(
    (state) => state.JobStageReducer.jobTimelineFormSubmission
  );

  // Set custom header for form
  const [customHeader, setCustomHeader] = useState(null);

  useEffect(() => {
    setCustomHeader(null);
    let stageId;
    let status;
    if (activeStep === 16 || activeStep === 17) {
      if (activeStep === 17) {
        status = "REJECTED";
      }
      switch (readOnlyInterviewNo) {
        case 1:
          stageId = 10;
          break;
        case 2:
          stageId = 11;
          break;
        case 3:
          stageId = 12;
          break;
        default:
      }
      setCustomHeader("Candidate Rejected / Cancelled by Client");
    } else if (activeStep === 27) {
      setCustomHeader("Interview Logs");
    }
    if (jobTimeLineData && isFormModalOpen == true) {
      dispatch(
        fetchJobTimelineFormSubmission({
          jobId: jobTimeLineData?.job?.id,
          jobStageId: stageId,
          candidateId: jobTimeLineData?.candidate?.id,
          status: status || null,
        })
      );
    }
  }, [jobTimeLineData, isFormModalOpen]);

  useEffect(() => {
    if (activeStep === 16 || activeStep === 17) {
      dispatch(fetchJobForm("submit_to_sales_rejection"));
    } else if (activeStep === 27) {
      dispatch(fetchJobForm("log_interview"));
    }
  }, [activeStep]);

  useEffect(() => {
    if (form) {
      setFormTemplate(form);
    }
  }, [form]);

  // Handle form submit
  const handleFormSubmit = async (event, values, newValues) => {
    let stageId;
    if (originalOrder === 10) {
      stageId = 10;
    } else if (originalOrder === 11) {
      stageId = 11;
    } else if (originalOrder === 12) {
      stageId = 12;
    }

    if (activeStep === 16 || activeStep === 17) {
      const timeLinePayload = {
        jobId: jobTimeLineData?.job?.id,
        jobStageId: stageId < 10 ? 10 : stageId,
        status: "REJECTED",
        candidateId: jobTimeLineData?.candidate?.id,
        formData: JSON.stringify(newValues),
        formId: parseInt(form?.formId),
        jobType: "interview_rejected",
        stepName: "Interview",
        subStepName: activeStep === 17 ? "Rejected" : "Cancelled by Client",
      };

      const interviewFormData = ObjectHelper.convertToFormDataNested({
        interviewId: interview?.id,
        status: "CANCELLED",
        cancellationBody: JSON.stringify(newValues),
      });

      const interviewPayload = {
        interviewId: interview?.id, // Include interviewId in the payload
        interviewFormData,
        date: interviewDate,
        setRefreshKey,
      };

      const combinedPayload = {
        timeLinePayload,
        interviewPayload,
        navigate,
      };

      dispatch(trainCancelInterview(combinedPayload));
    } else if (activeStep == 27) {
      const payload = {
        interviewId: interview?.id,
        status: "INTERVIEWLOGS",
        logsComment: newValues.comments,
      };
      const formData = ObjectHelper.convertToFormDataNested(payload);

      dispatch(addInterviewLogs(formData, setRefreshKey));
    }

    closeModal();
  };

  return (
    <Modal
      isOpen={isFormModalOpen}
      closeModal={closeModal}
      centered
      scrollable
      size="md"
      style={{ width: "50vw", maxWidth: "800px" }}
    >
      <ModalHeader
        toggle={closeModal}
        style={{
          paddingBottom: "0px",
        }}
      >
        <h5>{customHeader || "Cancel Interview"}</h5>
      </ModalHeader>
      <ModalBody>
        <Form
          template={formTemplate}
          userDetails={null}
          country={null}
          editData={null}
          onSubmit={handleFormSubmit}
          onFormFieldsChange={null}
          errorMessage={null}
          view={false}
          ref={formikRef}
        />
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-end gap-2">
          <Button
            className="btn btn-white border-dark fw-semibold"
            style={{ borderRadius: "8px" }}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>
          {isCancel ? (
            <Button
              className="btn-danger fw-semibold"
              style={{ borderRadius: "8px" }}
              onClick={() => {
                formikRef.current.formik?.submitForm();
              }}
            >
              {isLoading ? <Spinner size="sm" /> : "Confirm"}
            </Button>
          ) : (
            <Button
              className="btn-success fw-semibold"
              style={{ borderRadius: "8px" }}
              onClick={() => {
                formikRef.current.formik?.submitForm();
              }}
            >
              {isLoading ? <Spinner size="sm" /> : "Save"}
            </Button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ModalFormWrapper;
